import { CellProps, Table } from "rsuite";
import { UtilityDate } from "../dateUtil";

const { Cell } = Table;

export const DateCell = ({ rowData, dataKey, ...props }: CellProps) => {
  const date = UtilityDate.formatDate(rowData.CreateDate)
  return (
    <Cell {...props}>
      <p >{date}</p>
    </Cell>
  )
}
